export default { openDatabase, deleteDatabase }

export function openDatabase(name: string, version: number, migrate: (db: IDBDatabase) => void): Promise<IDBDatabase> {
    return new Promise((resolve, reject) => {
        const rq = indexedDB.open(name, version);
        rq.onupgradeneeded = e => {
            const db = (e.target as IDBOpenDBRequest).result;
            migrate(db);
        };
        rq.onsuccess = e => {
            const db = (e.target as IDBOpenDBRequest).result;
            resolve(db);
        };
        rq.onerror = e => {
            reject((e.target as IDBOpenDBRequest).error);
        };
    });
}

export function deleteDatabase(name: string) {
    indexedDB.deleteDatabase(name);
}
